import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-course-index-route.tsx
var LazyCourseIndexRoute = lazy(() => import("./course-index-route-Z3BRxN6w.js").then((n) => n.n).then((module) => ({ default: module.CourseIndexRoute })));
function CourseIndexRoute({ route, ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "index-route" }),
		children: /* @__PURE__ */ jsx(LazyCourseIndexRoute, {
			route,
			...props
		})
	});
}
var useCourseIndexRoute = () => {
	return useMemo(() => ({ "courses-index-route": { component: CourseIndexRoute } }), []);
};
//#endregion
export { useCourseIndexRoute };
